import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navigationLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

function Header() {
  const { pathname } = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 16);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('body-menu-open', isMenuOpen);

    return () => document.body.classList.remove('body-menu-open');
  }, [isMenuOpen]);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  const closeMobileMenu = () => setIsMenuOpen(false);

  return (
    <>
    <header
      className={`site-header ${isScrolled ? 'site-header--scrolled' : ''} ${
        isMenuOpen ? 'site-header--menu-open' : ''
      }`}
    >
      <div className="site-header__inner">
        <Link className="brand-mark" to="/" aria-label="Milestor home" onClick={closeMobileMenu}>
          <span className="brand-mark__name">Milestor</span>
        </Link>

        <nav className="site-nav" aria-label="Primary navigation">
          {navigationLinks.map((link) => {
            const isActive = pathname === link.to;

            return (
              <Link
                key={link.label}
                className={`site-nav__link ${isActive ? 'site-nav__link--active' : ''}`}
                to={link.to}
                aria-current={isActive ? 'page' : undefined}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <button
          className={`mobile-toggle ${isMenuOpen ? 'mobile-toggle--open' : ''}`}
          type="button"
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-controls="mobile-navigation"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((current) => !current)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

    </header>

    <div
      id="mobile-navigation"
      className={`mobile-menu ${isMenuOpen ? 'mobile-menu--open' : ''}`}
      aria-hidden={!isMenuOpen}
    >
      <nav className="mobile-menu__nav" aria-label="Mobile navigation">
        {navigationLinks.map((link, index) => (
          <Link
            key={link.label}
            className="mobile-menu__link"
            to={link.to}
            style={{ '--item-index': index }}
            tabIndex={isMenuOpen ? 0 : -1}
            onClick={closeMobileMenu}
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </div>
    </>
  );
}

export default Header;
